import { FlexBase, FlexTag } from "../Flex/Flex";

export class Span extends FlexBase<"span"> {
  tag: FlexTag = "span";
}
